import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastService } from "src/app/core/services/toast.service";
import { Router } from "@angular/router";
import { ApiService } from "src/app/core/services/api.service";
import { AuthenticationService } from "src/app/core/services/authentication.service";

@Component({
	selector: "app-avisolegal",
	templateUrl: "./avisolegal.component.html",
	styleUrls: ["./avisolegal.component.scss"],
})
export class AvisoLegalComponent implements OnInit {
	public loading = false;
	public forgotten = false;
	public register = false;

	public formAvisoLegal: FormGroup = this.fb.group({
		email: ["", [Validators.required, Validators.email]],
		password: ["", Validators.required],
	});

	email = "";

	constructor(
		private fb: FormBuilder,
		private toast: ToastService,
		private router: Router,
		private apiService: ApiService,
		private auth: AuthenticationService
	) {}

	ngOnInit(): void {}
}
